import React, {useRef, useState} from "react";
import './ClickAndDragScroll.css';

export const  ClickAndDragScroll = ({children}) => {
    const [isMouseDown, setIsMouseDown] = useState(false);
    const [startX, setStartX] = useState(null);
    const [startY, setStartY] = useState(null);
    const [scrollLeft, setScrollLeft] = useState(null);
    const [scrollTop, setScrollTop] = useState(null);
    const containerRef = useRef(null);

    const handleMouseDown = (e) => {
        setIsMouseDown(true);
        setStartX(e.clientX - containerRef.current.offsetLeft);
        setStartY(e.clientY - containerRef.current.offsetTop);
        setScrollLeft(containerRef.current.scrollLeft);
        setScrollTop(containerRef.current.scrollTop);
    };

    const handleMouseUp = () => {
        setIsMouseDown(false);
    };

    const handleMouseLeave = () => {
        setIsMouseDown(false);
    };

    const handleMouseMove = (e) => {
        if (!isMouseDown) return;
        e.preventDefault();
        const x = e.clientX - containerRef.current.offsetLeft;
        const y = e.clientY - containerRef.current.offsetTop;
        const walkX = (x - startX) * 2.5;
        const walkY = (y - startY) * 2.5;
        containerRef.current.scrollLeft = scrollLeft - walkX;
        containerRef.current.scrollTop = scrollTop - walkY;
    };

    return (
        <div ref={containerRef}
             onMouseDown={handleMouseDown}
             onMouseUp={handleMouseUp}
             onMouseLeave={handleMouseLeave}
             onMouseMove={handleMouseMove}
             style={{flex: 1, maxHeight: "100%", flexShrink: 1, flexGrow: 1, flexBasis: 1, overflow: "auto"}}
        >
            {children}
        </div>
    );
}